<template>
  <div class="loader-wrapper">
    <div class="loader">
      <div class="circle"></div>
      <div class="circle"></div>
      <div class="circle"></div>
      <div class="shadow"></div>
      <div class="shadow"></div>
      <div class="shadow"></div>
      <span>Loading</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "loadingIcon",
};
</script>
<style scoped>
.loader-wrapper {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 11;
  background: rgba(81, 94, 213, 0.74);
}

.loader {
  width: 140px;
  height: 60px;
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
}
.loader .circle {
  width: 20px;
  height: 20px;
  position: absolute;
  border-radius: 50%;
  background-color: #fff;
  left: 15%;
  transform-origin: 50%;
  animation: circle 0.5s alternate infinite ease;
}

@keyframes circle {
  0% {
    top: 60px;
    height: 5px;
    border-radius: 50px 50px 25px 25px;
    transform: scaleX(1.7);
  }
  40% {
    height: 20px;
    border-radius: 50%;
    transform: scaleX(1);
  }
  100% {
    top: 0%;
  }
}
.loader .circle:nth-child(2) {
  left: 45%;
  animation-delay: 0.2s;
}
.loader .circle:nth-child(3) {
  left: auto;
  right: 15%;
  animation-delay: 0.3s;
}
.loader .shadow {
  width: 20px;
  height: 4px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 62px;
  transform-origin: 50%;
  z-index: -1;
  left: 15%;
  filter: blur(1px);
  animation: shadow 0.5s alternate infinite ease;
}

@keyframes shadow {
  0% {
    transform: scaleX(1.5);
  }
  40% {
    transform: scaleX(1);
    opacity: 0.7;
  }
  100% {
    transform: scaleX(0.2);
    opacity: 0.4;
  }
}
.loader .shadow:nth-child(4) {
  left: 45%;
  animation-delay: 0.2s;
}
.loader .shadow:nth-child(5) {
  left: auto;
  right: 15%;
  animation-delay: 0.3s;
}
.loader span {
  position: relative;
  top: 75px;
  font-size: 20px;
  letter-spacing: 12px;
  color: #fff;
  width: 100%;
  text-align: center;
}
</style>
